<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/label/projects"
    >
        <!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <div :alvqa="alvqa + '-title'">
            {{ data.title ? data.title : $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED')}}
            </div>
        </template>

        <!-- FORM -->
        <template v-slot:editForm>
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_PROJECTS_CAPTION_TITLE')"
                        :context="context"
                        field="Title"
                        rules="required"
                        :alvqa="alvqa + '-textfield-project-title'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="Notes"
                        :label="$t('lang_GENERAL_CAPTION_NOTES')"
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-row>
            </v-col>

            <v-col>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_CAPTION_ALVID')"
                        :alvqa="alvqa + '-textfield-alvid'"
                        :clearable="false"
                        :readonly="true"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_PROJECTS_CAPTION_PROJECT_NUMBER')"
                        field="Projectnumber"
                        :context="context"
                        :alvqa="alvqa + '-textfield-catalogue-number'"
                    />
                </v-row>
            </v-col>

            <v-col>
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ProjectDate"
                        :label="$t('lang_LABEL_PROJECTS_CAPTION_PROJECT_START_DATE')"
                        :alvqa="alvqa + '-datepicker-project-date'"
                    />
                </v-row>
            </v-col>
            <v-col>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_PROJECTS_CAPTION_URL')"
                        field="Url"
                        :context="context"
                        :alvqa="alvqa + '-textfield-url'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Tags"
                        :label="$t('lang_PUBLISHING_RELEASES_CAPTION_TAGS')"
                        :alvqa="alvqa + '-textfield-tag'"
                    />
                </v-row>
            </v-col>
        </template>

        <!-- PANELS -->
        <template v-slot:panels>
            <LabelProjectsReleasesEditPanel />
            <DeletionDialog :useContextSetinVuex="true" />
            <SearchDialog
                context="Projects"
                subcontext="ProjectsReleases"
                searchcontext="ProjectsReleases"
                addcontext="ReleaseToProjects"
                addButtonLabel="lang_LABEL_PROJECTS_BUTTON_CAPTION_ADD_RELEASES"
                dialogTitle="lang_LABEL_PROJECTS_BUTTON_CAPTION_ADD_RELEASES"
                :alvqaContext="alvqa"
            >
                <template v-slot:itemTitle="{ item }">
                    {{ item.name }}
                </template>
                <template v-slot:itemSubtitle="{ item }">
                    EAN: {{ item.ean !== null ? item.ean : $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') }} | 
                    {{ $t('lang_GENERIC_CAPTION_CATALOGUE_NUMBER') }}: {{ item.catalogueNumber !== null ? item.catalogueNumber : $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') }} |
                    {{ $t('lang_LABEL_RELEASE_CAPTION_FIRST_MAIN_ARTIST') }}: {{ item.performer !== null ? $alvPlugin.getArtistOrPerformerName(item.performer) : $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') }}
                </template>
            </SearchDialog>
        </template>
    </BaseEditPage>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'

import LabelProjectsReleasesEditPanel from './_panels/1_releases/LabelProjectsReleasesEditPanel'

import SearchDialog from '@/components/_dialogs/SearchDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'

export default {
    name: "LabelProjectsEdit",
    components: {
        BaseEditPage,
        BaseEditPageTextField,
        BaseEditPageTextarea,
        BaseEditPageDatePicker,

        LabelProjectsReleasesEditPanel,

        SearchDialog,
        DeletionDialog
    },
    data() {
        return {
            context: 'LabelProjects',
            alvqa: 'label-projects-edit-form'
        }
    }
}
</script>